module.exports = __webpack_public_path__ + "img/22_DSC8126-min.e37b200d.jpg";